<template>
  <div class="house-importer-check-saldo">
    <app-panel title="Проверка сальдо по месяцам">
      <div slot="actions" class="house-importer-check-saldo__actions">
        <div class="house-importer-check-saldo__actions-block house-importer-check-saldo__actions-block_pt house-importer-check-saldo__actions-block_switch">
          <label class="app-datepicker__label">Проверять все загруженные месяцы</label>
          <vs-switch color="success" v-model="getParams.check_all"/>
        </div>
        <div class="house-importer-check-saldo__actions-block house-importer-check-saldo__actions-block_pt house-importer-check-saldo__actions-block_switch">
          <label class="app-datepicker__label">Сверять конечное сальдо</label>
          <vs-switch color="success" v-model="getParams.match_end_sal"/>
        </div>
        <div v-if="!getParams.check_all" class="house-importer-check-saldo__actions-block">
          <app-datepicker label="Месяц проверки" v-model="getParams.check_month" format="MMMM yyyy" minimum-view="month" :danger.sync="monthError" danger-text="Выберите месяц"/>
        </div>
        <div class="house-importer-check-saldo__actions-block house-importer-check-saldo__actions-block_pt">
          <app-button color="success" @click="getSaldo">Проверить</app-button>
        </div>
      </div>


      <div v-if="showTextErorr" class="house-importer-check-saldo__error-block">
        {{textError}}
      </div>
      <div v-else-if="!isLoading && isLoaded">
        <vs-collapse accordion>
          <vs-collapse-item v-for="(data, month) in saldoInfo" :key="month" class="house-importer-check-saldo__collapse-item house-importer-check-saldo-collapse-item">
            <div slot="header" class="house-importer-check-saldo-collapse-item__header">
              <span class="house-importer-check-saldo-collapse-item__header-month">{{$parseDateFromString(month) | moment('MMMM YYYY')}}</span>
              <span class="house-importer-check-saldo-collapse-item__header-count">({{data.length}})</span>
            </div>

            <div v-if="!data.length" class="house-importer-check-saldo-collapse-item__no-data">
              Информация пуста
            </div>
            <div v-else>
              <vs-table :data="data" hoverFlat pagination max-items="20" class="house-importer-check-saldo-collapse-item__table" no-data-text="История импортов пуста">
                <template slot="thead">
                  <vs-th>Аккаунт ELSA</vs-th>
                  <vs-th>Аккаунт Квартал</vs-th>
                  <vs-th>Начально сальдо Elsa</vs-th>
                  <vs-th>Начально сальдо Квартал</vs-th>
                  <vs-th>Конечное сальдо Elsa</vs-th>
                  <vs-th>Конечное сальдо Квартал</vs-th>
                  <vs-th>Начислено в месяце</vs-th>
                  <vs-th>Оплачено в месяце</vs-th>
                  <vs-th style="width: 1%" />
                </template>
                <template slot-scope="{data}">
                  <vs-tr :key="`${trIndex}-${tr.account}`" v-for="(tr, trIndex) in data">
                    <vs-td>{{tr.account}}</vs-td>
                    <vs-td>{{tr.kvartal_account}}</vs-td>
                    <vs-td>{{tr.st_sal_elsa | numberWithSpaces}}</vs-td>
                    <vs-td>{{tr.st_sal_kvartal | numberWithSpaces}}</vs-td>
                    <vs-td>{{tr.end_sal_elsa | numberWithSpaces}}</vs-td>
                    <vs-td>{{tr.end_sal_kvartal | numberWithSpaces}}</vs-td>
                    <vs-td>{{tr.charged | numberWithSpaces}}</vs-td>
                    <vs-td>{{tr.paid | numberWithSpaces}}</vs-td>
                    <vs-td>
                      <div @click="openPayments(tr.account)" class="link-icon" style="white-space: nowrap">
                        Показать платежи
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </div>
      <div class="house-importer-check-saldo__loading-block" v-else-if="isLoading">
        <div class="block-loading" />
        <div>Загружаю сальдо...</div>
      </div>
    </app-panel>
  </div>
</template>

<script>
  export default {
    name: "CheckSaldoPanel",
    props: {
      importInfo: {}
    },
    data() {
      return {
        isLoading: false,
        getParams: {
          check_all: true,
          match_end_sal: false,
          check_month: null
        },
        monthError: false,
        showTextErorr: false,
        isLoaded: false,
        textError: "",
        saldoInfo: {},
      }
    },
    methods: {
      async getSaldo(){
        this.showTextErorr = false;
        try{
          let params = Object.assign({import_id: this.importInfo.id}, this.getParams);

          if(params.check_all === false){
            if(params.check_month === null){
              this.monthError = true;
              return false;
            }
            else{
              params.check_month = this.$options.filters.moment(params.check_month, 'YYYY-MM');
            }
          }
          else{
            delete params.check_month;
          }
          this.isLoading = true;
          let {data} = await this.$http.get('import/houses/check_salary', {params: params});
          this.saldoInfo = data;
          this.isLoaded = true;
        }
        catch(e){
          if (e.response) {
            if(e.response.status === 404){
              this.showTextErorr = true;
              this.textError = "Импортируйте файлы с сальдо на указынный месяц";
            }
            else if(e.response.status === 418){
              this.showTextErorr = true;
              this.textError = "Импортируйте файлы с сальдо";
            }
            else{
              this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
            }
          }
          else{
            this.$vs.notify({color: 'danger', title: 'ERROR', text: e.message});
          }
        }
        finally{
          setTimeout(() => {
            this.isLoading = false;
          }, 300);
        }
      },
      openPayments(accountNumber){
        this.$emit('open-payments', accountNumber);
      }
    },
    watch: {
      'getParams.check_all'(){
        if(this.getParams.check_all){
          this.monthError = false;
          this.getParams.check_month = null;
        }
      }
    }
  }
</script>

<style lang="scss">
.house-importer-check-saldo{

  &__actions{
    display: flex;
    align-items: center;
    margin: 0 -7.5px;
  }

  &__actions-block{
    display: flex;
    padding: 0 7.5px;

    &_pt{
      padding-top: 22px;
    }

    &_switch{
      .app-datepicker__label{
        margin-right: 5px;
      }
    }
  }

  &__loading-block{
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .block-loading{
      width: 60px;
      height: 60px;
      flex: 0;
      margin-bottom: 20px;
    }
  }

  &__error-block{
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    font-weight: 500;
    text-align: center;
    font-size: 18px;
  }

  &__collapse-item{

  }
}

  .house-importer-check-saldo-collapse-item{
    .vs-collapse-item--header{
      padding: 15px 5px;
      font-size: 18px;
    }

    &.vs-collapse-item{
      border-bottom: 1px solid rgba(0,0,0,.2);
    }

    &.open-item .con-content--item{
      padding: 5px 5px 15px!important;
    }

    &__header{
      display: flex;
      align-items: center;

      &-month{
        font-size: 18px;
        line-height: 1.1;
        text-transform: capitalize;
      }

      &-count{
        font-size: 16px;
        line-height: 1.1;
        margin-left: 5px;
      }
    }

    &__table{
      .vs-table--tbody{
        border: none;
        background: #fff;
      }

      .vs-table--thead th{
        padding: 0!important;
        border-bottom: 1px solid rgba(0,0,0,.125);

        .vs-table-text{
          text-align: left;
          position: relative;
          vertical-align: bottom;
          padding: .75rem 10px;
          background: transparent;
          font-size: 12px;
        }
      }

      .vs-table{
        .vs-table--tr:nth-child(2n+1){
          background: #f5f8fa;
        }
      }

      .tr-values td{
        padding: .5rem 10px;
        font-size: 12px;
      }

      .vs-table--pagination{
        justify-content: center;
      }
    }

    &__no-data{
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 500;
      font-size: 16px;
    }
  }
</style>